import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from './login.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  email = '';
  password = '';
  isLoggedIn = true;
  token = 'not defined';

  constructor(private loginService: LoginService, private router: Router) { }

  ngOnInit() {
    this.loginService.isLoggedIn$.subscribe(res => {
      if (!res) {
        this.email = ''; this.password = '';
      }

    });
  }

  onSubmit() {
    this.loginService.login(this.email, this.password);
  }

}
